import { gql } from 'graphql.macro';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  JSONObject: any;
};

export type Activity = {
  __typename?: 'Activity';
  appName: Scalars['String'];
  timestampEnd: Scalars['Date'];
  timestampStart: Scalars['Date'];
  windowName: Scalars['String'];
};

export type BaseNotification = {
  id: Scalars['ID'];
  /** @deprecated message is deprecated. Use notification.{title/body} instead. */
  message?: Maybe<Scalars['String']>;
  notification: NotificationContent;
  timestamp: Scalars['Date'];
  type: NotificationType;
};

export type Cluster = {
  __typename?: 'Cluster';
  appName?: Maybe<Scalars['String']>;
  client_id?: Maybe<Scalars['ID']>;
  createdBy?: Maybe<ClusterCreatedBy>;
  date: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  item_id?: Maybe<Scalars['ID']>;
  metaData?: Maybe<Scalars['JSONObject']>;
  miscellaneousReason?: Maybe<Scalars['String']>;
  nodes?: Maybe<Array<Maybe<ClusterNode>>>;
  overlappingClusters?: Maybe<Array<Maybe<Cluster>>>;
  predictedClientId?: Maybe<Scalars['ID']>;
  predictedItemId?: Maybe<Scalars['ID']>;
  predictedProjectId?: Maybe<Scalars['ID']>;
  predictedTaskId?: Maybe<Scalars['ID']>;
  project_id?: Maybe<Scalars['ID']>;
  source: ClusterSource;
  subTitle?: Maybe<Scalars['String']>;
  task_id?: Maybe<Scalars['ID']>;
  timesheet_entry_id?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  userId: Scalars['ID'];
  user_id: Scalars['ID'];
  versionNumber: Scalars['String'];
  windowName?: Maybe<Scalars['String']>;
};

export enum ClusterCreatedBy {
  DRAG = 'drag',
  ML = 'ml',
  SPLIT = 'split'
}

export type ClusterNode = {
  __typename?: 'ClusterNode';
  activities?: Maybe<Array<Maybe<Activity>>>;
  cluster_id: Scalars['ID'];
  duration?: Maybe<Scalars['Int']>;
  edited?: Maybe<Scalars['Boolean']>;
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  original_cluster_id?: Maybe<Scalars['ID']>;
  previous_cluster_id?: Maybe<Scalars['ID']>;
  subTitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum ClusterSortBy {
  DATE = 'date',
  TITLE = 'title'
}

export enum ClusterSource {
  ACTIVITY = 'activity',
  CALENDAR = 'calendar',
  EMAIL = 'email'
}

export type Company = {
  __typename?: 'Company';
  activitiesRetention?: Maybe<Scalars['Int']>;
  allowDuplicateLines?: Maybe<Scalars['Boolean']>;
  allowDuplicateTimesheets?: Maybe<Scalars['Boolean']>;
  allowNegativeHours?: Maybe<Scalars['Boolean']>;
  archivedOn?: Maybe<Scalars['Date']>;
  associateClassWithTask?: Maybe<Scalars['Boolean']>;
  calendarRetention?: Maybe<Scalars['Int']>;
  classDimensionEnabled?: Maybe<Scalars['Boolean']>;
  clientDisplayName?: Maybe<Scalars['String']>;
  contractDimensionEnabled?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['Date']>;
  customerDimensionEnabled?: Maybe<Scalars['Boolean']>;
  defaultNotesToTaskDescription?: Maybe<Scalars['Boolean']>;
  emailRetention?: Maybe<Scalars['Int']>;
  employeeDimensionEnabled?: Maybe<Scalars['Boolean']>;
  entities?: Maybe<Array<Maybe<Entity>>>;
  id?: Maybe<Scalars['ID']>;
  intacctCompanyId?: Maybe<Scalars['String']>;
  integrations?: Maybe<Array<Maybe<Integration>>>;
  itemDimensionEnabled?: Maybe<Scalars['Boolean']>;
  itemDisplayName?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  maxHoursPerSheet?: Maybe<Scalars['String']>;
  maxHoursPerWeekday?: Maybe<Scalars['String']>;
  maxHoursPerWeekendDay?: Maybe<Scalars['String']>;
  mfaRequired: Scalars['Boolean'];
  minHoursPerSheet?: Maybe<Scalars['String']>;
  minHoursPerWeekday?: Maybe<Scalars['String']>;
  minHoursPerWeekendDay?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  projectDimensionEnabled?: Maybe<Scalars['Boolean']>;
  projectDisplayName?: Maybe<Scalars['String']>;
  showBillable?: Maybe<Scalars['Boolean']>;
  showCustom?: Maybe<Scalars['Boolean']>;
  showDepartmentLocation?: Maybe<Scalars['Boolean']>;
  showDescriptionFirst?: Maybe<Scalars['Boolean']>;
  showItem?: Maybe<Scalars['Boolean']>;
  showProject?: Maybe<Scalars['Boolean']>;
  showTask?: Maybe<Scalars['Boolean']>;
  showTimeType?: Maybe<Scalars['Boolean']>;
  syncEnd?: Maybe<Scalars['Date']>;
  syncError?: Maybe<Scalars['String']>;
  syncJob?: Maybe<Scalars['String']>;
  syncStart?: Maybe<Scalars['Date']>;
  taskDimensionEnabled?: Maybe<Scalars['Boolean']>;
  taskDisplayName?: Maybe<Scalars['String']>;
  tenantType?: Maybe<TenantType>;
  timesheetDuration?: Maybe<Scalars['Int']>;
  unrestricted_approver?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['Date']>;
  userRestriction?: Maybe<UserRestriction>;
  validateEmployeeDates?: Maybe<Scalars['Boolean']>;
  validateProjectDates?: Maybe<Scalars['Boolean']>;
  validateTaskEndDate?: Maybe<Scalars['Boolean']>;
  validateTaskStartDate?: Maybe<Scalars['Boolean']>;
  vendorDimensionEnabled?: Maybe<Scalars['Boolean']>;
  warehouseDimensionEnabled?: Maybe<Scalars['Boolean']>;
  weekStart?: Maybe<Scalars['Int']>;
  workdayHours?: Maybe<Scalars['String']>;
};

export type Entity = {
  __typename?: 'Entity';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EntryDimensionValue = {
  dimension_value_id?: InputMaybe<Scalars['String']>;
};

export type GetNotificationsInput = {
  channel: NotificationChannel;
  unread?: InputMaybe<Scalars['Boolean']>;
};

export type Integration = {
  __typename?: 'Integration';
  id?: Maybe<Scalars['Int']>;
  integration_id?: Maybe<Scalars['Int']>;
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type JobStatus = {
  __typename?: 'JobStatus';
  complete?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  progress?: Maybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  readAllNotifications?: Maybe<ReadAllNotificationsResponse>;
  saveTimesheet?: Maybe<SaveTimesheetResponse>;
};


export type MutationSaveTimesheetArgs = {
  payload: SaveTimesheetPayload;
};

export type NewRowPayload = {
  dimensionValues?: InputMaybe<Scalars['JSONObject']>;
  entries?: InputMaybe<Array<InputMaybe<SaveTimesheetEntryPayload>>>;
  order?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
};

export type Notification = BaseNotification & {
  __typename?: 'Notification';
  id: Scalars['ID'];
  /** @deprecated message is deprecated. Use notification.{title/body} instead. */
  message?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
  metaId?: Maybe<Scalars['String']>;
  notification: NotificationContent;
  pushIsRead?: Maybe<Scalars['Boolean']>;
  timestamp: Scalars['Date'];
  type: NotificationType;
};

export enum NotificationChannel {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH'
}

export type NotificationContent = {
  __typename?: 'NotificationContent';
  body: Scalars['String'];
  title: Scalars['String'];
};

export enum NotificationType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  PROMOTION = 'PROMOTION',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING'
}

export type PushNotification = BaseNotification & {
  __typename?: 'PushNotification';
  data?: Maybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  /** @deprecated message is deprecated. Use notification.{title/body} instead. */
  message?: Maybe<Scalars['String']>;
  notification: NotificationContent;
  timestamp: Scalars['Date'];
  topic: Scalars['String'];
  type: NotificationType;
};

export type Query = {
  __typename?: 'Query';
  clusters?: Maybe<Array<Maybe<Cluster>>>;
  company?: Maybe<Company>;
  notifications: Array<Notification>;
  timesheet: Timesheet;
};


export type QueryClustersArgs = {
  sortBy?: InputMaybe<ClusterSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  timesheetId: Scalars['ID'];
};


export type QueryNotificationsArgs = {
  input: GetNotificationsInput;
};


export type QueryTimesheetArgs = {
  id: Scalars['ID'];
};

export type ReadAllNotificationsResponse = {
  __typename?: 'ReadAllNotificationsResponse';
  notifications: Array<Notification>;
};

export type RowDimensionValuesPayload = {
  client?: InputMaybe<Scalars['String']>;
  item?: InputMaybe<Scalars['String']>;
  otherValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  project?: InputMaybe<Scalars['String']>;
  removeValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  task?: InputMaybe<Scalars['String']>;
  timeType?: InputMaybe<Scalars['String']>;
};

export type SaveTimesheetEntryPayload = {
  billable?: InputMaybe<Scalars['Boolean']>;
  confirmedClientId?: InputMaybe<Scalars['String']>;
  confirmedItemId?: InputMaybe<Scalars['String']>;
  confirmedProjectId?: InputMaybe<Scalars['String']>;
  confirmedTaskId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  dimensions?: InputMaybe<Array<InputMaybe<EntryDimensionValue>>>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  timeTypeId?: InputMaybe<Scalars['String']>;
  timesheetRowId?: InputMaybe<Scalars['String']>;
};

export type SaveTimesheetPayload = {
  deleteEntries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deleteRows?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  entries?: InputMaybe<Array<InputMaybe<SaveTimesheetEntryPayload>>>;
  id?: InputMaybe<Scalars['ID']>;
  newRows?: InputMaybe<Array<InputMaybe<NewRowPayload>>>;
  startDate?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<TimesheetStatus>;
  updateRows?: InputMaybe<Array<InputMaybe<UpdateRowPayload>>>;
};

export type SaveTimesheetResponse = {
  __typename?: 'SaveTimesheetResponse';
  jobId?: Maybe<Scalars['Int']>;
  timesheetId?: Maybe<Scalars['String']>;
};

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type Subscription = {
  __typename?: 'Subscription';
  jobStatus?: Maybe<JobStatus>;
  newNotification: PushNotification;
};


export type SubscriptionJobStatusArgs = {
  jobId: Scalars['String'];
};

export enum TenantType {
  CUSTOMER_PRODUCTION = 'customer_production',
  DEBUG = 'debug',
  DEVELOPER = 'developer',
  IMPLEMENTATION = 'implementation',
  PARTNER_PRODUCTION = 'partner_production',
  SALES_DEMO = 'sales_demo',
  SANDBOX = 'sandbox'
}

export type Timesheet = {
  __typename?: 'Timesheet';
  createdExternally?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['Date'];
  entries?: Maybe<Array<Maybe<TimesheetEntry>>>;
  id: Scalars['ID'];
  integrationError?: Maybe<Scalars['String']>;
  startDate: Scalars['Date'];
  status?: Maybe<TimesheetStatus>;
  timeSpent?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['Date']>;
};

export type TimesheetEntry = {
  __typename?: 'TimesheetEntry';
  billable?: Maybe<Scalars['Boolean']>;
  confirmedClientId?: Maybe<Scalars['ID']>;
  confirmedItemId?: Maybe<Scalars['ID']>;
  confirmedProjectId?: Maybe<Scalars['ID']>;
  confirmedTaskId?: Maybe<Scalars['ID']>;
  createdExternally?: Maybe<Scalars['Boolean']>;
  date: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  integrationError?: Maybe<Scalars['String']>;
  integrationSyncTime?: Maybe<Scalars['Date']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<TimesheetStatus>;
  timeTypeId?: Maybe<Scalars['ID']>;
  timesheet?: Maybe<Scalars['ID']>;
  timesheetRowId?: Maybe<Scalars['ID']>;
};

export enum TimesheetStatus {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  DRAFT = 'DRAFT',
  INVOICED = 'INVOICED',
  PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
  PARTIALLY_DECLINED = 'PARTIALLY_DECLINED',
  SUBMITTED = 'SUBMITTED'
}

export type UpdateRowPayload = {
  dimensionValues?: InputMaybe<RowDimensionValuesPayload>;
  id: Scalars['ID'];
  order?: InputMaybe<Scalars['Int']>;
};

export enum UserRestriction {
  ANY = 'ANY',
  PROJECTS = 'PROJECTS',
  PROJECTS_AND_TASKS = 'PROJECTS_AND_TASKS'
}

export type ReadNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadNotificationsMutation = { __typename?: 'Mutation', readAllNotifications?: { __typename?: 'ReadAllNotificationsResponse', notifications: Array<{ __typename?: 'Notification', id: string, type: NotificationType, timestamp: any, meta?: string | null, metaId?: string | null, pushIsRead?: boolean | null, notification: { __typename?: 'NotificationContent', title: string, body: string } }> } | null };

export type GetCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id?: string | null, name?: string | null, logoUrl?: string | null, userRestriction?: UserRestriction | null, showCustom?: boolean | null, showProject?: boolean | null, showTask?: boolean | null, showItem?: boolean | null, showDepartmentLocation?: boolean | null, showTimeType?: boolean | null, showBillable?: boolean | null, weekStart?: number | null, timesheetDuration?: number | null, workdayHours?: string | null, minHoursPerSheet?: string | null, maxHoursPerSheet?: string | null, minHoursPerWeekday?: string | null, maxHoursPerWeekday?: string | null, minHoursPerWeekendDay?: string | null, maxHoursPerWeekendDay?: string | null, classDimensionEnabled?: boolean | null, customerDimensionEnabled?: boolean | null, employeeDimensionEnabled?: boolean | null, itemDimensionEnabled?: boolean | null, projectDimensionEnabled?: boolean | null, taskDimensionEnabled?: boolean | null, vendorDimensionEnabled?: boolean | null, contractDimensionEnabled?: boolean | null, associateClassWithTask?: boolean | null, clientDisplayName?: string | null, projectDisplayName?: string | null, taskDisplayName?: string | null, itemDisplayName?: string | null, defaultNotesToTaskDescription?: boolean | null, allowDuplicateLines?: boolean | null, allowDuplicateTimesheets?: boolean | null, showDescriptionFirst?: boolean | null, validateProjectDates?: boolean | null, validateEmployeeDates?: boolean | null, validateTaskStartDate?: boolean | null, validateTaskEndDate?: boolean | null, intacctCompanyId?: string | null, archivedOn?: any | null, syncError?: string | null, syncJob?: string | null, syncStart?: any | null, syncEnd?: any | null, activitiesRetention?: number | null, emailRetention?: number | null, calendarRetention?: number | null, created_at?: any | null, updated_at?: any | null, unrestricted_approver?: string | null, tenantType?: TenantType | null, allowNegativeHours?: boolean | null, mfaRequired: boolean, entities?: Array<{ __typename?: 'Entity', id: string, name: string } | null> | null, integrations?: Array<{ __typename?: 'Integration', id?: number | null, integration_id?: number | null, name?: string | null, logoUrl?: string | null } | null> | null } | null };

export type FetchNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchNotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: string, type: NotificationType, timestamp: any, meta?: string | null, pushIsRead?: boolean | null, metaId?: string | null, notification: { __typename?: 'NotificationContent', title: string, body: string } }> };

export type OnNewNotificationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnNewNotificationSubscription = { __typename?: 'Subscription', newNotification: { __typename?: 'PushNotification', id: string, type: NotificationType, topic: string, data?: any | null, timestamp: any, notification: { __typename?: 'NotificationContent', title: string, body: string } } };


export const ReadNotificationsDocument = gql`
    mutation readNotifications {
  readAllNotifications {
    notifications {
      id
      type
      notification {
        title
        body
      }
      timestamp
      meta
      metaId
      pushIsRead
    }
  }
}
    `;
export type ReadNotificationsMutationFn = Apollo.MutationFunction<ReadNotificationsMutation, ReadNotificationsMutationVariables>;

/**
 * __useReadNotificationsMutation__
 *
 * To run a mutation, you first call `useReadNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationsMutation, { data, loading, error }] = useReadNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useReadNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ReadNotificationsMutation, ReadNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadNotificationsMutation, ReadNotificationsMutationVariables>(ReadNotificationsDocument, options);
      }
export type ReadNotificationsMutationHookResult = ReturnType<typeof useReadNotificationsMutation>;
export type ReadNotificationsMutationResult = Apollo.MutationResult<ReadNotificationsMutation>;
export type ReadNotificationsMutationOptions = Apollo.BaseMutationOptions<ReadNotificationsMutation, ReadNotificationsMutationVariables>;
export const GetCompanyDocument = gql`
    query GetCompany {
  company {
    id
    name
    entities {
      id
      name
    }
    integrations {
      id
      integration_id
      name
      logoUrl
    }
    logoUrl
    userRestriction
    showCustom
    showProject
    showTask
    showItem
    showDepartmentLocation
    showTimeType
    showBillable
    weekStart
    timesheetDuration
    workdayHours
    minHoursPerSheet
    maxHoursPerSheet
    minHoursPerWeekday
    maxHoursPerWeekday
    minHoursPerWeekendDay
    maxHoursPerWeekendDay
    classDimensionEnabled
    customerDimensionEnabled
    employeeDimensionEnabled
    itemDimensionEnabled
    projectDimensionEnabled
    taskDimensionEnabled
    vendorDimensionEnabled
    contractDimensionEnabled
    associateClassWithTask
    clientDisplayName
    projectDisplayName
    taskDisplayName
    itemDisplayName
    defaultNotesToTaskDescription
    allowDuplicateLines
    allowDuplicateTimesheets
    showDescriptionFirst
    validateProjectDates
    validateEmployeeDates
    validateTaskStartDate
    validateTaskEndDate
    intacctCompanyId
    archivedOn
    syncError
    syncJob
    syncStart
    syncEnd
    activitiesRetention
    emailRetention
    calendarRetention
    created_at
    updated_at
    unrestricted_approver
    tenantType
    allowNegativeHours
    mfaRequired
  }
}
    `;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const FetchNotificationsDocument = gql`
    query fetchNotifications {
  notifications(input: {channel: PUSH}) {
    id
    type
    notification {
      title
      body
    }
    timestamp
    meta
    pushIsRead
    metaId
  }
}
    `;

/**
 * __useFetchNotificationsQuery__
 *
 * To run a query within a React component, call `useFetchNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<FetchNotificationsQuery, FetchNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchNotificationsQuery, FetchNotificationsQueryVariables>(FetchNotificationsDocument, options);
      }
export function useFetchNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchNotificationsQuery, FetchNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchNotificationsQuery, FetchNotificationsQueryVariables>(FetchNotificationsDocument, options);
        }
export type FetchNotificationsQueryHookResult = ReturnType<typeof useFetchNotificationsQuery>;
export type FetchNotificationsLazyQueryHookResult = ReturnType<typeof useFetchNotificationsLazyQuery>;
export type FetchNotificationsQueryResult = Apollo.QueryResult<FetchNotificationsQuery, FetchNotificationsQueryVariables>;
export const OnNewNotificationDocument = gql`
    subscription OnNewNotification {
  newNotification {
    id
    type
    notification {
      title
      body
    }
    topic
    data
    timestamp
  }
}
    `;

/**
 * __useOnNewNotificationSubscription__
 *
 * To run a query within a React component, call `useOnNewNotificationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNewNotificationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNewNotificationSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnNewNotificationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnNewNotificationSubscription, OnNewNotificationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnNewNotificationSubscription, OnNewNotificationSubscriptionVariables>(OnNewNotificationDocument, options);
      }
export type OnNewNotificationSubscriptionHookResult = ReturnType<typeof useOnNewNotificationSubscription>;
export type OnNewNotificationSubscriptionResult = Apollo.SubscriptionResult<OnNewNotificationSubscription>;